import { render, staticRenderFns } from "./MoneyView.vue?vue&type=template&id=1301a508&scoped=true&"
import script from "./MoneyView.vue?vue&type=script&lang=js&"
export * from "./MoneyView.vue?vue&type=script&lang=js&"
import style0 from "./MoneyView.vue?vue&type=style&index=0&id=1301a508&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1301a508",
  null
  
)

export default component.exports